<template>
  <div class="inline-block relative">
    <div
      ref="triggerRef"
      :data-tooltip-target="tooltipId"
      :data-tooltip-placement="placement"
      :data-tooltip-trigger="trigger"
    >
      <slot />
    </div>
    <div
      :id="tooltipId"
      role="tooltip"
      :class="[
        'absolute z-50 invisible inline-block px-3 py-2 font-medium text-white opacity-0 transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs tooltip',
          threeLines ? 'text-xs text-center w-[240px]' 
          : twoLines ? 'text-xs text-center w-[124px]' 
          : 'whitespace-nowrap text-sm'
      ]"
    >
      <slot name="content">
        {{ content }}
      </slot>
      <div
        class="tooltip-arrow"
        data-popper-arrow
      />
    </div>
  </div>
</template>

<script>
import { initTooltips } from 'flowbite';

export default {
  name: 'ToolTipComponent',
  props: {
    placement: {
      type: String,
      default: 'top',
    },
    content: {
      type: String,
      default: '',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    twoLines: {
      type: Boolean,
      default: false,
    },
    threeLines: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tooltipId: `tooltip-${Math.random().toString(36).slice(2, 9)}`,
    };
  },
  mounted() {
    this.$nextTick(() => {
      initTooltips();
    });
  },
};
</script>
